import { render, staticRenderFns } from "./ElementStudioPresets.vue?vue&type=template&id=156379d0&"
import script from "./ElementStudioPresets.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioPresets.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioPresets.vue?vue&type=style&index=0&id=156379d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports